import axios, { CancelTokenSource } from 'axios';

// Adapter to link AbortSignal with Axios CancelToken
export function fromAbortSignal(signal?: AbortSignal): CancelTokenSource {
  const source = axios.CancelToken.source();

  signal?.addEventListener('abort', () => {
    source.cancel('Operation canceled due to abort signal.');
  });

  return source;
}
